export const ICON_SIZE_MAP = {
    s: 14,
    m: 16,
    l: 18,
    xl: 20,
};
